// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell-button-base-w0xDc {
  width: max-content;
  margin-left: auto;
  margin-right: 4px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/cell-button/cell-button.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".base {\n  width: max-content;\n  margin-left: auto;\n  margin-right: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `cell-button-base-w0xDc`
};
export default ___CSS_LOADER_EXPORT___;
